<template>
  <base-page-layout :title="$getLoggedUser().client" class="home">
    <span class="current-month">{{ currentMonth }}</span>

    <div class="mercapromo-cards-grouping">
      <MercapromoCard title="Cupons" :loading="loading">
        <ProgressBarChart class="mt-2" barColor="#ECEDF0" textColor="#969ea7" :percent="100" />
        <ProgressBarChart barColor="#00B395" textColor="#00B395" :percent="couponsWithEligibleQtyPercent" />
        <ProgressBarChart barColor="#4B525A" textColor="#4B525A" :percent="couponsWithEarnPercent" />

        <div class="card-extra-info">
          <div class="subtitle-with-number">
            <mf-icon fill :size="16" color="#ECEDF0" icon="fiber_manual_record" />
            <span class="number text-cinza-l30">{{ metrics.coupons.with_products | localeString }}</span>
            <span class="subtitle">Cupons com produtos das ofertas</span>
          </div>
          <div class="subtitle-with-number">
            <mf-icon fill :size="16" color="#00B395" icon="fiber_manual_record" />
            <span class="number text-marca-1">{{ metrics.coupons.with_eligible_quantity | localeString }}</span>
            <span class="subtitle">Cupons com produto em qtd. elegível</span>
          </div>
          <div class="subtitle-with-number">
            <mf-icon fill :size="16" color="#4B525A" icon="fiber_manual_record" />
            <span class="number" style="color: #4b525a">{{ metrics.coupons.with_earn | localeString }}</span>
            <span class="subtitle">Cupons com ofertas aplicadas</span>
          </div>
        </div>
      </MercapromoCard>

      <MercapromoCard title="Unidades vendidas" :loading="loading">
        <div>
          <mf-progress-bar class="pt-8" :partialValue="soldUnitsInOfferPercent" :totalValue="100" hide-legend hide-percentage />
          <span class="text-marca-1">{{ soldUnitsInOfferPercent }}%</span>
        </div>

        <div class="card-extra-info">
          <div class="subtitle-with-number">
            <span class="number text-cinza-l30">{{ metrics.sold_units.total | localeString }}</span>
            <span class="subtitle">Total de unidades vendidas</span>
          </div>
          <div class="subtitle-with-number">
            <span class="number text-marca-1">{{ metrics.sold_units.total_in_offer | localeString }}</span>
            <span class="subtitle">Total de unidades vendidas na oferta</span>
          </div>
        </div>
      </MercapromoCard>

      <MercapromoCard
        title="Clientes com desconto"
        :text="localeString(uniqueClientsInOffers)"
        tooltip="CPF únicos que receberam descontos."
        :loading="loading"
      >
        <template v-slot:additional>
          <div class="card-extra-info">
            <div class="subtitle-with-number">
              <span class="blur-text green-text">+XX,X%</span>
              <span class="subtitle">em relação ao ano anterior</span>
            </div>
          </div>
        </template>
      </MercapromoCard>

      <MercapromoCard title="Desconto concedido" :text="totalDiscount" tooltip="Soma dos descontos concedidos pelas ofertas Mercapromo." :loading="loading">
        <template v-slot:additional>
          <div class="card-extra-info">
            <div class="subtitle-with-number">
              <span class="blur-text green-text">+XX,X%</span>
              <span class="subtitle">em relação ao ano anterior</span>
            </div>
          </div>
        </template>
      </MercapromoCard>
    </div>

    <div class="cbm-opportunity">
      <div class="cbm-text-icon-container">
        <mf-icon fill :size="50" color="#0063C6" icon="lightbulb_circle" />
        <div class="cbm-text-container">
          <span class="title">Está procurando por dados e ofertas exclusivas?</span>
          <span>Não perca tempo e faça parte do time de Mercamonster, obtenha o CBM e amplie as ofertas do seu comércio. </span>
        </div>
      </div>
      <get-cbm-form-modal id="get-cbm-form" ref="getCbm"></get-cbm-form-modal>
    </div>

    <div class="cbm-cards-grouping">
      <div class="d-flex flex-column">
        <div class="minor-cbm-cards-grouping">
          <MercapromoCard title="Faturamento">
            <p class="big-number-blur">R$X,Xxx</p>
            <template v-slot:additional>
              <div class="card-extra-info">
                <div class="subtitle-with-number">
                  <span class="blur-text green-text">+XX,X%</span>
                  <span class="subtitle">em relação ao ano anterior</span>
                </div>
              </div>
            </template>
          </MercapromoCard>

          <MercapromoCard title="Clientes inativos recentes">
            <p class="big-number-blur">XXX</p>
            <template v-slot:additional>
              <div class="card-extra-info">
                <div class="subtitle-with-number">
                  <span class="blur-text red-text">+X,X%</span>
                  <span class="subtitle">a mais que o mês anterior</span>
                </div>
              </div>
            </template>
          </MercapromoCard>

          <MercapromoCard title="Ticket médio">
            <v-tabs
              v-model="templateTab"
              class="tabs-menu-upper"
              background-color="transparent"
              color="primary"
              height="33px"
              grow
              slider-color="#00B395"
              active-class="active-tab"
            >
              <v-tab v-for="item in tabsMenuItems" :key="item.name" @click="selectedMonth = 1">
                <span style="font-size: 14px; text-transform: capitalize">{{ item.name }}</span>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="templateTab">
              <v-tab-item v-for="item in tabsMenuItems" :key="item.name">
                <div class="month-button">
                  <mf-button color="cinza-0" type="icon" icon="arrow_left" :disabled="selectedMonth === 0" @click="previous" />
                  <span class="text-cinza-d10" style="text-transform: capitalize">{{ showMonth.month }}</span>
                  <mf-button color="cinza-0" type="icon" icon="arrow_right" :disabled="selectedMonth === 2" @click="next" />
                </div>

                <p class="big-number-blur">{{ showMonth.month }}</p>

                <div class="card-extra-info">
                  <div class="subtitle-with-number">
                    <span class="blur-text green-text">{{ showMonth.value }}</span>
                    <span class="subtitle">de um cliente não clube</span>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </MercapromoCard>
        </div>

        <div class="minor-cbm-cards-grouping">
          <MercapromoCard title="Top produtos" subtitle="Queda faturamento">
            <div class="results-example-card">
              <ArrowBox is-negative text="Clientes" value="-X,XX%" is-blur />
              <ArrowBox is-negative text="Faturamento" value="-X,XX%" is-blur />
            </div>
            <v-divider class="mt-2" />
            <template v-slot:additional>
              <div class="card-extra-info">
                <span class="text-cinza-d10">Potencial de ganho</span>
                <div class="subtitle-with-number">
                  <span class="blur-text">R$ XX.XXX,XX</span>
                  <v-chip small>15 produtos</v-chip>
                </div>
              </div>
            </template>
          </MercapromoCard>

          <MercapromoCard title="Top produtos" subtitle="Queda clientes">
            <div class="results-example-card">
              <ArrowBox is-negative text="Clientes" value="-X,XX%" is-blur />
              <ArrowBox is-negative text="Faturamento" value="-X,XX%" is-blur />
            </div>
            <v-divider class="mt-2" />
            <template v-slot:additional>
              <div class="card-extra-info">
                <span class="text-cinza-d10">Potencial de ganho</span>
                <div class="subtitle-with-number">
                  <span class="blur-text">R$ XX.XXX,XX</span>
                  <v-chip small>15 produtos</v-chip>
                </div>
              </div>
            </template>
          </MercapromoCard>

          <MercapromoCard title="Maior ganho potencial">
            <div class="results-example-card">
              <ArrowBox text="Clientes" value="-X,XX%" is-blur />
              <ArrowBox text="Faturamento" value="-X,XX%" is-blur />
            </div>
            <v-divider class="mt-2" />
            <template v-slot:additional>
              <div class="card-extra-info">
                <span class="text-cinza-d10">Potencial de ganho</span>
                <div class="subtitle-with-number">
                  <span class="blur-text">R$ XX.XXX,XX</span>
                  <v-chip small>12 produtos</v-chip>
                </div>
              </div>
            </template>
          </MercapromoCard>
        </div>
      </div>
      <MercapromoCard class="mt-4 pa-4">
        <div class="opportunity-card-title">
          <img :src="require('@/assets/icons/mar.ia-cor.svg')" alt="maria" width="36" height="36" />
          <span class="text-cinza-d10">Oportunidades</span>
        </div>
        <div class="opportunity-card-text">
          Identificamos <span class="blur-text text-marca-1">X </span> <span class="text-marca-1 bold">produtos</span> com queda de vendas em
          <span class="blur-text text-marca-1">Lojas - XX Xxx Xxxxx</span>, comparando com mês anterior.
        </div>
        <div class="d-flex flex-column" style="gap: 8px">
          <span class="text-cinza-d10">Quedas identificadas: </span>
          <ArrowBox is-negative text="Faturamento" value="-X,XX%" is-blur />
          <ArrowBox is-negative text="Clientes" value="-X,XX%" is-blur />
        </div>
        <div class="opportunity-card-text">
          <span>Realizando ações propostas através da análise de dados, é possível recuperar:</span>
        </div>
        <div class="dashed-divider"></div>
        <div class="opportunity-footer">
          <div class="d-flex flex-column">
            <div class="d-flex">
              <mf-icon size="26" color="#0a8533" fill>chart_data</mf-icon>
              <span class="text-cinza-d10">Ganho potencial</span>
            </div>
            <span class="blur-text">R$ XX.XXX,XX</span>
          </div>
          <mf-button size="sm" label="Ver detalhes" icon="arrow_forward" icon-position="right" @click="openModal" />
        </div>
        <div class="clip-ticket-right"></div>
        <div class="clip-ticket-left"></div>
      </MercapromoCard>
    </div>

    <!-- <binds /> -->
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ProgressBarChart from '@/components/ProgressBarChart.vue'
import MercapromoCard from '../components/MercapromoCard.vue'
import GetCbmFormModal from '../components/GetCbmFormModal.vue'
// import Binds from '@/plugins/binds/Binds.vue'
import ArrowBox from '../components/ArrowBox.vue'
import { QUERY_MERCAPROMO_METRICS } from '../../graphql/index'
import { abbreviation } from '@/config/helpers.js'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  components: {
    BasePageLayout,
    ProgressBarChart,
    MercapromoCard,
    ArrowBox,
    GetCbmFormModal,
    // Binds,
  },
  data: () => ({
    templateTab: 1,
    selectedMonth: 1,
    loading: false,
    metrics: {
      type: '',
      coupons: {
        with_products: 0,
        with_eligible_quantity: 0,
        with_earn: 0,
      },
      sold_units: {
        total: 0,
        total_in_offer: 0,
      },
      clients: {
        uniques_in_offer: 0,
      },
      discounts: {
        total: '',
      },
      created_at: '',
    },
  }),
  computed: {
    tabsMenuItems() {
      return [
        {
          name: 'Geral',
          disabled: true,
        },
        {
          name: 'Clube',
          disabled: true,
        },
        {
          name: 'Fora clube',
          disabled: true,
        },
      ]
    },
    showMonth() {
      switch (this.selectedMonth) {
        case 0:
          return { month: this.previousMonth, value: '+X,XX%' }
        case 1:
          return { month: this.currentMonth, value: '-X,XX%' }
        case 2:
          return { month: this.nextMonth, value: '+XX,XX' }
        default:
          return { month: this.currentMonth, value: '-XX,XX' }
      }
    },
    previousMonth() {
      return moment().subtract(1, 'months').format('MMMM YYYY')
    },
    currentMonth() {
      return moment().format('MMMM YYYY')
    },
    nextMonth() {
      return moment().add(1, 'months').format('MMMM YYYY')
    },
    uniqueClientsInOffers() {
      return this.metrics.clients.uniques_in_offer ? this.metrics.clients.uniques_in_offer : 0
    },
    totalDiscount() {
      return this.metrics.discounts.total ? `R$ ${abbreviation(this.metrics.discounts.total, { isCurrency: true })}` : ''
    },
    couponsWithEligibleQtyPercent() {
      const eligibleQty = this.metrics.coupons.with_eligible_quantity
      const totalCouponsWithProducts = this.metrics.coupons.with_products
      if (eligibleQty && totalCouponsWithProducts) {
        return Math.round((eligibleQty * 100) / totalCouponsWithProducts)
      } else return 0
    },
    couponsWithEarnPercent() {
      const earn = this.metrics.coupons.with_earn
      const totalCouponsWithProducts = this.metrics.coupons.with_products
      if (earn && totalCouponsWithProducts) {
        return Math.round((earn * 100) / totalCouponsWithProducts)
      } else return 0
    },
    soldUnitsInOfferPercent() {
      const totalSold = this.metrics.sold_units.total
      const soldInOffer = this.metrics.sold_units.total_in_offer
      if (totalSold && soldInOffer) {
        return Math.round((soldInOffer * 100) / totalSold)
      } else return 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      try {
        const { data } = await this.$apollo.query({
          query: QUERY_MERCAPROMO_METRICS,
          fetchPolicy: 'no-cache',
        })

        this.metrics = data.mercapromoMetrics
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    next() {
      if (this.selectedMonth !== 2) {
        this.selectedMonth += 1
      }
    },
    previous() {
      if (this.selectedMonth !== 0) {
        this.selectedMonth -= 1
      }
    },
    openModal() {
      this.$refs.getCbm.openedDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
.current-month {
  color: $cinza-d10;
  font-size: 22px;
  text-transform: capitalize;
}

.mercapromo-cards-grouping {
  margin: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.cbm-cards-grouping {
  margin: 8px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  gap: 16px;

  .minor-cbm-cards-grouping {
    margin: 16px 0 0 0;
    display: flex;
    gap: 18px;
  }
}

.text-cinza-l30 {
  color: $cinza-l30;
}

.text-cinza-d10 {
  color: $cinza-d10;
}

.text-marca-1 {
  color: $marca-1;
}

.big-number-blur {
  font-size: 36px;
  color: $cinza-0;
  margin-bottom: 0;
  filter: blur(9px);
  user-select: none;
}

.month-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blur-text {
  user-select: none;
  filter: blur(4px);
  font-size: 16px;
  font-weight: 700;
}
.card-extra-info {
  margin-top: 16px;
  display: flex;
  flex-direction: column;

  .subtitle-with-number {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    gap: 6px;
  }

  .number {
    font-size: 16px;
    font-weight: 700;
  }

  .green-text {
    color: #0a8533;
  }

  .red-text {
    color: #b3280d;
  }

  .subtitle {
    flex: 1;
  }
}

.active-tab {
  color: $marca-1;
}

::v-deep .tabs-menu-upper {
  margin-bottom: 12px;
  border-bottom: 1px solid $cinza-l20;

  & .v-slide-group__prev {
    display: none;
  }

  & .v-slide-group__next {
    display: none;
  }
}

.cbm-opportunity {
  margin: 8px;
  margin-top: 18px;
  padding: 22px 40px;
  background-color: #d2e9ff;
  border: 1px solid $cinza-l80;
  border-radius: 3px;
  min-height: 86px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .cbm-text-icon-container {
    display: flex;
    align-items: center;
    gap: 30px;
    .cbm-text-container {
      display: flex;
      flex-direction: column;
      color: $marca-0;

      .title {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }
}

.results-example-card {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.opportunity-card-title {
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
}

.opportunity-card-text {
  margin: 22px 0;
  color: $cinza-0;
}

.dashed-divider {
  position: absolute;
  width: 96%;
  left: 8px;
  bottom: 162px;
  border-top: 2px dashed $cinza-l70;
}

.opportunity-footer {
  margin-top: 32px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  height: 100%;
}

.clip-ticket-right {
  width: 24px;
  height: 24px;
  background-color: #f6f6f8;
  border-radius: 50%;
  position: absolute;
  margin-right: -12px;
  right: 0;
  bottom: 126px;
  box-shadow: inset 1px 0px 0px #aaaaaa;
}

.clip-ticket-left {
  width: 24px;
  height: 24px;
  background-color: #f6f6f8;
  border-radius: 50%;
  position: absolute;
  margin-left: -12px;
  left: 0;
  bottom: 126px;
  box-shadow: inset -1px 0px 0px #aaaaaa;
}

@media screen and (max-width: 933px) {
  .cbm-opportunity {
    padding: 22px 40px;
    flex-direction: column;
    align-items: center;
    border-radius: 12px;
    gap: 12px;

    .cbm-text-icon-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      text-align: center;
    }
  }

  .cbm-cards-grouping {
    flex-wrap: wrap;

    .minor-cbm-cards-grouping {
      margin: 16px 0 0 0;
      display: flex;
      flex-wrap: wrap;
      gap: 18px;
    }
  }
}
</style>
